/** SPA route paths — merchant portal at site root; admin under /admin. */

export const MERCHANT_LOGIN_PATH = "/";
export const MERCHANT_LOGIN_ALIAS = "/login";

/** Merchant portal (no /m prefix). */
export const MERCHANT = {
  home: "/home",
  signup: "/signup",
  wallet: "/wallet",
  kyb: "/kyb",
  apiKeys: "/api-keys",
  security: "/security",
  webhooks: "/webhooks",
  webhookEvents: "/webhook-events",
  cards: "/cards",
  card: (id) => `/cards/${id}`,
  users: "/users",
  transactions: "/transactions",
  audit: "/audit",
  usage: "/usage",
};

/** Admin console (not on public base URLs). */
export const ADMIN_BASE = "/admin";
export const ADMIN_LOGIN_PATH =
  process.env.REACT_APP_ADMIN_LOGIN_PATH || "/internal/console-7h3k9m2p";

export const ADMIN = {
  home: "/admin",
  merchants: "/admin/merchants",
  merchant: (id) => `/admin/merchants/${id}`,
  balanceFunding: "/admin/balance-funding",
  crypto: "/admin/crypto",
  kybQueue: "/admin/kyb-queue",
  providers: "/admin/providers",
  cards: "/admin/cards",
  users: "/admin/users",
  userKyc: (userId) => `/admin/users/${userId}/kyc`,
  cardTypes: "/admin/card-types",
  fees: "/admin/fees",
  transactions: "/admin/transactions",
  auditLogs: "/admin/audit-logs",
  analytics: "/admin/analytics",
  webhooks: "/admin/webhooks",
  apiDocs: "/admin/api-docs",
  settings: "/admin/settings",
};

/** @deprecated use ADMIN.home */
export const ADMIN_HOME_PATH = ADMIN.home;

const MERCHANT_APP_PREFIXES = [
  MERCHANT.home,
  MERCHANT.wallet,
  MERCHANT.kyb,
  MERCHANT.apiKeys,
  MERCHANT.security,
  MERCHANT.webhooks,
  MERCHANT.webhookEvents,
  MERCHANT.cards,
  MERCHANT.users,
  MERCHANT.transactions,
  MERCHANT.audit,
  MERCHANT.usage,
];

export function isMerchantLoginPath(pathname) {
  return pathname === MERCHANT_LOGIN_PATH || pathname === MERCHANT_LOGIN_ALIAS;
}

export function isAdminLoginPath(pathname) {
  return pathname === ADMIN_LOGIN_PATH;
}

export function isAdminAppPath(pathname) {
  return pathname === ADMIN_BASE || pathname.startsWith(`${ADMIN_BASE}/`);
}

export function isMerchantPublicPath(pathname) {
  return isMerchantLoginPath(pathname) || pathname === MERCHANT.signup;
}

export function isMerchantAppPath(pathname) {
  if (isMerchantPublicPath(pathname) || isAdminAppPath(pathname) || isAdminLoginPath(pathname)) {
    return false;
  }
  if (pathname === "/m" || pathname.startsWith("/m/")) return true;
  return MERCHANT_APP_PREFIXES.some(
    (p) => pathname === p || pathname.startsWith(`${p}/`),
  );
}
